import React, { Component, useLayoutEffect, useRef } from "react";

class Hero extends Component {
  render() {
    return (
      <section id="heroSection">
        <div id="heroContainer">
          {/** 
            <Image fluid src="https://media.geeksforgeeks.org/wp-content/uploads/20210425000233/test-300x297.png" roundedCircle="true"></Image>
            */}
          <div>
            <h1>Mackenzie May</h1>
          </div>
          <div>
            <h2>Software Developer</h2>
          </div>
        </div>
        {/**
         * 
        <div id="heroContainer2">
        </div>

         */}
      </section>
    );
  }
}

export default Hero;

{
  /* maybe have a random title or a title that keeps switching out?
celestial architect (when the site is in full starmode)
front end developer
software dev (force this after celestial architect)
boardgamer
dead god
website maker
weeb
delusions of grandeur
allergic to melons
he/him
email ninja
panicrazia
aniquest
future olympic sailing gold medalist
Bo Jackson
electric boogaloo
quest for more money
freerange rabbiteer
aquarium lover
pizza enthusiast
hi
watched one piece
Sanji is better than Zoro (maybe make this forced to come after the one piece thing)
worm reader
traveler
Rochesterian
ai overlord
doesn't like almonds
immortality seeker
machine god 
tarot reader
日本語下手
bad at smash bros
noun verber
mahjonger
*/
}
{
  /**Front End Developer */
}
